var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-avatar',{staticClass:"lighten-5",attrs:{"color":_vm.color,"size":_vm.size ? _vm.size : '48'}},[_c('h4',{staticClass:"text-capitalize font-weight-light white--text"},[_vm._v(_vm._s(_vm.initials))])])
}
var staticRenderFns = []

export { render, staticRenderFns }